import getCurrentEventOrganizer from 'owa-calendar-compose-form-store/lib/selectors/getCurrentEventOrganizer';
import getCustomMessageViewState from 'owa-mail-tips/lib/utils/getCustomMessageViewState';
import getFromAddress from 'owa-calendar-compose-form-orchestration/lib/utils/getFromAddress';
import type MailTipDetails from 'owa-mail-tips/lib/store/schema/MailTipDetails';
import type MailTipsCacheEntry from 'owa-mail-tips/lib/store/schema/MailTipsCacheEntry';
import type SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';
import type { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import type { NestedMruCache } from 'owa-nested-mru-cache';
import type EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { isRoom, getRoomEmailFromLocation } from 'owa-location-persona';

const getLocationMailTipMessageViewState = (
    locations: EnhancedLocation[],
    mailTips: NestedMruCache<MailTipsCacheEntry>,
    formId: string
): InfoBarMessageViewState[] => {
    const organizer: SingleRecipientType = getCurrentEventOrganizer(formId);
    const fromEmailAddress: string = getFromAddress(formId, organizer);

    const customMessageInfos: MailTipDetails[] = locations.reduce(
        (initialCustomMessageInfos: MailTipDetails[], location: EnhancedLocation) => {
            if (!location || !isRoom(location.PostalAddress)) {
                return initialCustomMessageInfos;
            }

            const locationEmailAddressWrapper = getRoomEmailFromLocation(location);
            const mailTipsCacheEntry: MailTipsCacheEntry = mailTips.get(
                fromEmailAddress,
                locationEmailAddressWrapper.EmailAddress
            );
            const locationMailTips = mailTipsCacheEntry ? mailTipsCacheEntry.value : {};

            if (locationMailTips.CustomMailTip) {
                initialCustomMessageInfos.push({
                    recipient: {
                        Name: location.DisplayName,
                        ...locationEmailAddressWrapper,
                    },
                    message: locationMailTips.CustomMailTip,
                });
            }

            return initialCustomMessageInfos;
        },
        <MailTipDetails[]>[]
    );

    const messageViewState: InfoBarMessageViewState = getCustomMessageViewState(customMessageInfos);

    // add aria properties for the location mail tip messages
    if (messageViewState) {
        messageViewState.ariaProps = {
            role: 'alert',
            live: 'assertive',
        };
    }

    return messageViewState ? [messageViewState] : [];
};

export default getLocationMailTipMessageViewState;
